"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/BaseWidgetController");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var lodash_1 = require("lodash");
var routeParams_1 = require("../routeParams");
var helpers_1 = require("../helpers");
var main_1 = require("../main");
var MembersController = /** @class */ (function (_super) {
    tslib_1.__extends(MembersController, _super);
    function MembersController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.membersToAdd = new Set();
        _this.setMembers = function (groupId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, members, siteMembersMap, currentMember, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getMembers(groupId)];
                    case 1:
                        _a = _b.sent(), members = _a.members, siteMembersMap = _a.siteMembersMap, currentMember = _a.currentMember;
                        this.setProps({
                            siteMembers: members,
                            siteMembersMap: siteMembersMap,
                            currentMember: currentMember,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.filterMembers = function (groupId, query) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filteredMembers, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filteredMembers = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.api.filterMembers(groupId, query)];
                    case 2:
                        filteredMembers = (_a.sent()).data
                            .members;
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        this.logger.log(e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.setProps({
                            membersQueryResponse: {
                                query: query,
                                members: filteredMembers,
                            },
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.addMember = function (groupId, memberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.membersToAdd.add(memberId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.api.addToGroup(groupId, [memberId])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(groupId)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        e_3 = _a.sent();
                        this.logger.log(e_3);
                        return [3 /*break*/, 6];
                    case 5:
                        this.membersToAdd.delete(memberId);
                        if (!this.membersToAdd.size) {
                            this.setGroupMembers(groupId);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.openCurrentUserProfile = function () {
            _this.getLocation().to('/account/profile');
        };
        _this.openUserProfile = function (siteMemberId) {
            _this.getLocation().to("/profile/" + siteMemberId + "/profile");
        };
        _this.api = new social_groups_api_1.MembersApi(_this.getSiteToken(), _this.getApiBaseUrl());
        return _this;
    }
    MembersController.prototype.getMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members, siteMembersMap, id, currentMember;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchMembers(groupId, members)];
                    case 1:
                        members = _a.sent();
                        siteMembersMap = lodash_1.keyBy(members, 'siteMemberId');
                        id = this.getCurrentUser().id;
                        currentMember = siteMembersMap[id];
                        return [2 /*return*/, { members: members, siteMembersMap: siteMembersMap, currentMember: currentMember }];
                }
            });
        });
    };
    MembersController.prototype.fetchMembers = function (groupId, members) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_4, data, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listAllMembers(groupId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 2:
                        e_4 = _a.sent();
                        console.log(e_4);
                        return [3 /*break*/, 3];
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.api.listGroupMembers(groupId)];
                    case 4:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 5:
                        e_5 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.setGroupMembers = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_MEMBERS_EVENT, groupId, false);
        }
        catch (e) { }
    };
    MembersController.prototype.setProps = function (props) {
        this.controllerConfig.setProps(props);
    };
    MembersController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupId, e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setProps({
                            membersActions: {
                                setMembers: this.setMembers,
                                addMember: this.addMember,
                                openCurrentUserProfile: this.openCurrentUserProfile,
                                openUserProfile: this.openUserProfile,
                                filterMembers: this.filterMembers,
                            },
                            siteMembers: [],
                            siteMembersMap: {},
                            currentMember: social_groups_api_1.Anonymous,
                            membersQueryResponse: social_groups_api_1.MembersQueryInitialResponse,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.getGroupId()];
                    case 2:
                        groupId = _a.sent();
                        return [4 /*yield*/, this.setMembers(groupId)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_6 = _a.sent();
                        main_1.MainController.logger.log(e_6);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MembersController.prototype.getGroupId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var api, group, groupId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEditorMode()) return [3 /*break*/, 2];
                        api = new social_groups_api_1.default(this.getSiteToken(), this.getApiBaseUrl());
                        return [4 /*yield*/, helpers_1.getFirstGroup(api)];
                    case 1:
                        group = _a.sent();
                        return [2 /*return*/, group.groupId];
                    case 2:
                        groupId = routeParams_1.groupRoute(this.getLocation()).groupId;
                        return [2 /*return*/, groupId];
                }
            });
        });
    };
    return MembersController;
}(BaseWidgetController_1.BaseWidgetController));
exports.MembersController = MembersController;
//# sourceMappingURL=MembersController.js.map